"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyConfiguration = void 0;
const live_env_1 = require("@ledgerhq/live-env");
const cache_1 = require("@ledgerhq/live-network/cache");
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const defaultConfig_1 = __importDefault(require("./defaultConfig"));
exports.getCurrencyConfiguration = (0, cache_1.makeLRUCache)((currency) => __awaiter(void 0, void 0, void 0, function* () {
    const currencyConfigUrl = (0, live_env_1.getEnv)("CURRENCY_CONFIG_BASE_URL");
    try {
        const remoteConfig = yield (0, network_1.default)({
            method: "GET",
            url: `${currencyConfigUrl}/config/${currency.family}/${currency.id}.json`,
        });
        if (remoteConfig.data != null) {
            return remoteConfig.data;
        }
        else {
            throw new Error(`No currency configuration available remotely for ${currency.id}`);
        }
    }
    catch (e) {
        if (defaultConfig_1.default &&
            defaultConfig_1.default.config &&
            defaultConfig_1.default.config[currency.family] &&
            defaultConfig_1.default.config[currency.family][currency.id]) {
            console.warn(`No currency configuration available for ${currency.id}, using local configuration as backup`);
            return Promise.resolve(defaultConfig_1.default.config[currency.family][currency.id]);
        }
        else {
            throw new Error(`No currency configuration available for ${currency.id}`);
        }
    }
}), currency => currency.id, { ttl: 1 * 60 * 60 * 1000 });
//# sourceMappingURL=index.js.map